// extracted by mini-css-extract-plugin
module.exports = {"avatarWrapper":"styles_avatarWrapper__elkju"};